/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { DefinitionParameterValueDto } from './DefinitionParameterValueDto';
import {
    DefinitionParameterValueDtoFromJSON,
    DefinitionParameterValueDtoFromJSONTyped,
    DefinitionParameterValueDtoToJSON,
} from './DefinitionParameterValueDto';

/**
 * 
 * @export
 * @interface DefinitionParameterValueSetDto
 */
export interface DefinitionParameterValueSetDto {
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterValueSetDto
     */
    id: string;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof DefinitionParameterValueSetDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterValueSetDto
     */
    setIdentifier: string;
    /**
     * 
     * @type {Array<DefinitionParameterValueDto>}
     * @memberof DefinitionParameterValueSetDto
     */
    values?: Array<DefinitionParameterValueDto> | null;
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterValueSetDto
     */
    protocolId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterValueSetDto
     */
    $type?: DefinitionParameterValueSetDtoTypeEnum;
}


/**
 * @export
 */
export const DefinitionParameterValueSetDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoDefinitionParameterValueSetDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DefinitionParameterValueSetDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DefinitionParameterValueSetDtoTypeEnum = typeof DefinitionParameterValueSetDtoTypeEnum[keyof typeof DefinitionParameterValueSetDtoTypeEnum];



/**
 * Check if a given object implements the DefinitionParameterValueSetDto interface.
 */
export function instanceOfDefinitionParameterValueSetDto(value?: unknown): value is DefinitionParameterValueSetDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DefinitionParameterValueSetDtoTypeEnum)[0];
}

export function DefinitionParameterValueSetDtoFromJSON(json: any): DefinitionParameterValueSetDto {
    return DefinitionParameterValueSetDtoFromJSONTyped(json, false);
}

export function DefinitionParameterValueSetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefinitionParameterValueSetDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'setIdentifier': json['setIdentifier'],
        'values': json['values'] == null ? undefined : ((json['values'] as Array<any>).map(DefinitionParameterValueDtoFromJSON)),
        'protocolId': json['protocolId'] == null ? undefined : json['protocolId'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DefinitionParameterValueSetDtoToJSON(value?: DefinitionParameterValueSetDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'origin': EntityOriginToJSON(value['origin']),
        'setIdentifier': value['setIdentifier'],
        'values': value['values'] == null ? undefined : ((value['values'] as Array<any>).map(DefinitionParameterValueDtoToJSON)),
        'protocolId': value['protocolId'],
        '$type': value['$type'],
    });
}

